<template>
  <div>
    <b-container>
      <b-row>
        <transition name="fade" appear>
          <b-col cols="12" class="search-full mb-4">
            <b-input-group class="search-form">
              <template v-slot:prepend>
                <b-icon-search class="cursor" />
              </template>
              <template v-slot:append>
                <b-link
                  href="#"
                  class="search-clear"
                  :class="showClear ? `active` : ``"
                  @click="clearKeyword"
                >
                  CLEAR
                </b-link>
                <b-icon-x
                  class="search-close"
                  :class="!showClear ? `active` : ``"
                  @click="$emit('close')"
                />
              </template>
              <b-form-input
                v-focus
                v-model="keyword"
                :value="keyword"
                @keyup=";(searching = true), searchFollowing()"
              ></b-form-input>
            </b-input-group>
          </b-col>
        </transition>

        <b-row align-h="between" class="search-options" align-v="center">
          <b-col cols="6" md="auto" class="p-0 mb-2">
            <a
              href="#"
              class="pt-5"
              v-if="showAllResults && !toplist.length > 0"
              @click.stop.prevent="backToplist()"
            >
              <b-icon-arrow-left></b-icon-arrow-left>
              Back</a
            >
            <b-dd
              block
              :text="category.id ? category.name : `Choose category`"
              v-if="toplist.length > 0"
            >
              <b-dd-item @click="clearCategory()">None (default)</b-dd-item>
              <b-dd-divider></b-dd-divider>
              <b-dd-item
                @click="selectCategory(cat)"
                v-for="(cat, key) in categories"
                :key="`cat_` + key"
                :disabled="isDisabled(cat)"
                >{{ cat.label }}
              </b-dd-item>
            </b-dd>
          </b-col>
          <b-col
            cols="6"
            md="auto"
            class="p-0 mb-2"
            v-if="(searching && showClear) || (list_results && showAllResults)"
          >
            <b-dd block :text="sortBy.value ? sortBy.descr : `Sort by`">
              <b-dd-item
                @click="selectSorting(type)"
                v-for="(type, key) in list_type"
                :key="`sort_` + key"
                :disabled="isDisabled(type)"
                >{{ type.description }}
              </b-dd-item>
            </b-dd>
          </b-col>
        </b-row>
      </b-row>

      <!-- Top lists -->
      <b-row
        align-v="center"
        class="py-5"
        v-for="(top, topKey) in filteredToplist"
        :key="`top_` + topKey"
      >
        <b-col cols="12">
          <b-row align-h="between" class="m-0 p-0">
            <b-col cols="6">
              <h5 class="font-weight-bold text-capitalize">
                {{ top.list_type.description }}
              </h5>
            </b-col>
            <b-col cols="6" class="align-right">
              <a
                v-if="top.influencers.length > 4"
                class="cursor"
                @click.stop.prevent="showAll(top)"
                >See all</a
              >
            </b-col>
          </b-row>
        </b-col>

        <b-overlay
          :show="loading"
          rounded="sm"
          variant="transparent"
          opacity="1"
          blur="1px"
          class="custom-overlay-ii"
        >
          <b-row
            v-if="top.influencers && !loading"
            align-v="center"
            class="position-relative"
          >
            <b-col
              cols="10"
              md="6"
              lg="3"
              class="overflow-hidden text-left py-3 p-0 m-0"
              v-for="(influencer, userKey) in top.influencers"
              :key="`inf_` + userKey"
            >
              <transition name="fade" appear>
                <b-row
                  :align-v="
                    user.influencer_uid !== influencer.influencer_uid
                      ? `center`
                      : `start`
                  "
                  class="p-0 m-0"
                  v-if="top.show_all ? true : userKey <= showLimitCount - 1"
                >
                  <b-col cols="4" class="p-0 pl-2 pr-0">
                    <div
                      class="rounded-circle cursor"
                      :style="
                        `background:url(` +
                        influencer.profile_photo_url +
                        `) center/cover;
                padding: 50%`
                      "
                      @click="
                        $router.push(
                          '/influencer/' +
                            influencer.influencer_uid +
                            `/` +
                            influencer.username
                        )
                      "
                    />
                  </b-col>

                  <b-col>
                    <p
                      class="d-block font-weight-bold overflow-hidden m-0"
                      v-if="influencer.full_name"
                    >
                      <b-link
                        class="text-white influencer-name"
                        :to="
                          `/influencer/` +
                          influencer.influencer_uid +
                          `/` +
                          influencer.username
                        "
                        v-text="influencer.full_name"
                      />
                    </p>
                    <small
                      class="grey-light d-block"
                      v-if="influencer"
                      v-text="`@` + influencer.username"
                    />
                    <b-button
                      size="sm"
                      variant="black"
                      class="rounded-pill float-left cursor my-2"
                      v-if="influencer.is_following"
                      @click="
                        unFollow({
                          user: influencer,
                          userKey: userKey,
                          topKey: topKey,
                        })
                      "
                    >
                      <small
                        class="v-center text-capitalize"
                        style="letter-spacing: 0.5px"
                      >
                        <small>following</small>
                      </small>
                    </b-button>

                    <b-button
                      size="sm"
                      variant="primary"
                      class="rounded-pill float-left px-3 my-2"
                      v-show="
                        !influencer.is_following &&
                        influencer.influencer_uid !== user.influencer_uid
                      "
                      @click="follow(influencer)"
                    >
                      <small
                        class="v-center text-capitalize"
                        style="letter-spacing: 0.5px"
                      >
                        <small
                          v-if="
                            user.influencer_uid !== influencer.influencer_uid
                          "
                          >follow</small
                        >
                      </small>
                    </b-button>
                  </b-col>
                </b-row>
              </transition>
              <confirmation-modal
                :id="influencer.influencer_uid + userKey + topKey"
                :ok-title="`Unfollow @` + influencer.username"
                :only-confirm="true"
                @is-confirmed="true ? confirmUnfollow(influencer) : ``"
              ></confirmation-modal>
            </b-col>
          </b-row>
          <p class="text-grey" v-if="!top.influencers.length > 0 && !loading">
            No match found
          </p>
        </b-overlay>
      </b-row>

      <!-- Search results -->
      <b-overlay
        :show="loading"
        rounded="sm"
        variant="transparent"
        opacity="1"
        blur="1px"
        class="custom-overlay"
      >
        <b-row align-v="center" class="py-5">
          <b-col
            cols="12"
            class="m-0"
            v-if="(searching && showClear) || (list_results && showAllResults)"
          >
            <b-row class="m-0 p-0 results">
              <b-col cols="12">
                <h5 class="font-weight-bold text-capitalize">
                  {{ list_results.length }} Results
                </h5>
              </b-col>
            </b-row>

            <p
              class="text-grey no-match"
              v-if="!list_results.length > 0 && !loading && !sortBy.value"
            >
              There is no match found for
              <strong>"{{ keyword }}"</strong>
              <span v-if="category.name && category.id">
                on
                <strong>{{ category.name }}</strong>
              </span>
            </p>
            <p
              class="text-grey no-match-sortby"
              v-if="!list_results.length > 0 && !loading && sortBy.value"
            >
              No recent <strong>{{ sortBy.descr.toLowerCase() }}</strong> for
              <strong>{{ keyword }}</strong>
              <span v-if="category.name && category.id">
                on
                <strong>{{ category.name }}</strong>
              </span>
            </p>
          </b-col>
          <b-col
            class="overflow-hidden text-left m-0 py-3"
            v-for="(influencer, userKey) in list_results"
            :key="`query_` + userKey"
            cols="10"
            md="6"
            lg="3"
          >
            <transition name="fade" appear>
              <b-row
                :align-v="
                  user.influencer_uid !== influencer.influencer_uid
                    ? `center`
                    : `start`
                "
              >
                <b-col cols="4" class="p-0 pl-1 pr-0">
                  <div
                    class="rounded-circle cursor"
                    :style="
                      `background:url(` +
                      influencer.profile_photo_url +
                      `) center/cover;
                padding: 50%`
                    "
                    @click="
                      $router.push(
                        '/influencer/' +
                          influencer.influencer_uid +
                          `/` +
                          influencer.username
                      )
                    "
                  />
                </b-col>

                <b-col class="pr-0">
                  <p
                    class="d-block font-weight-bold overflow-hidden m-0"
                    v-if="influencer.full_name"
                  >
                    <b-link
                      class="text-white influencer-name"
                      :to="
                        `/influencer/` +
                        influencer.influencer_uid +
                        `/` +
                        influencer.username
                      "
                      v-text="influencer.full_name"
                    />
                  </p>
                  <small
                    class="grey-light d-block"
                    v-if="influencer"
                    v-text="`@` + influencer.username"
                  />
                  <b-button
                    size="sm"
                    variant="black"
                    class="rounded-pill float-left cursor my-2 btn-unfollow"
                    v-if="influencer.is_following"
                    @click="unFollow(influencer)"
                  >
                    <small
                      class="v-center text-capitalize"
                      style="letter-spacing: 0.5px"
                    >
                      <small>following</small>
                    </small>
                  </b-button>

                  <b-button
                    size="sm"
                    variant="primary"
                    class="rounded-pill float-left px-3 my-2 btn-follow"
                    v-show="
                      !influencer.is_following &&
                      influencer.influencer_uid !== user.influencer_uid
                    "
                    @click="follow(influencer)"
                  >
                    <small
                      class="v-center text-capitalize"
                      style="letter-spacing: 0.5px"
                    >
                      <small>follow</small>
                    </small>
                  </b-button>
                </b-col>
              </b-row>
            </transition>
            <confirmation-modal
              :id="influencer.influencer_uid"
              :ok-title="`Unfollow @` + influencer.username"
              :only-confirm="true"
              @is-confirmed="true ? confirmUnfollow(influencer) : ``"
            ></confirmation-modal>
          </b-col>
        </b-row>
      </b-overlay>
    </b-container>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapState, mapActions, mapMutations } from 'vuex'
import ConfirmationModal from '@/views/components/ConfirmationModal'

export default {
  name: 'SearchInfluencer',

  data() {
    return {
      keyword: '',
      perPage: 10,
      showAllResults: false,
      showClear: false,
      searching: false,
      loading: false,
      limit: 36,
      page: 1,
      sortBy: {
        value: '',
        descr: '',
      },
      category: {
        id: '',
        name: '',
      },
      showLimitCount: 4,
      filteredToplist: [],
      unfollow: {
        user: '',
        key: '',
        top: '',
        modalId: '',
      },
    }
  },

  components: {
    ConfirmationModal,
  },

  directives: {
    focus: {
      inserted: function (el) {
        el.focus()
      },
    },
  },

  async mounted() {
    this.loading = true
    await this.getInfluencerCategories()
    await this.getToplist()
    this.loading = false
  },

  computed: {
    ...mapState({
      user: (state) => state.auth.user,
      list: (state) => state.influencer.list,
      total: (state) => state.influencer.total,
      has_more: (state) => state.influencer.has_more,
      categories: (state) => state.influencer.categories,
      toplist: (state) => state.influencer.top_list,
      list_type: (state) => state.influencer.list_type,
      list_results: (state) => state.influencer.list_results,
    }),

    params() {
      return {
        perpage: this.perPage,
        page: this.page,
        keyword: this.keyword,
        catid: this.category.id,
        sortby: this.sortBy.value,
      }
    },
  },

  watch: {
    toplist(newValue) {
      if (newValue) {
        this.filteredToplist = newValue
        this.filteredToplist.forEach((top) => {
          this.$set(top, 'show_all', false)
        })
      }
    },
  },

  methods: {
    ...mapActions({
      getRandomInfluencer: 'influencer/getRandomInfluencer',
      searchInfluencer: 'influencer/searchInfluencer',
      getInfluencerCategories: 'influencer/getInfluencerCategories',
      getToplist: 'influencer/getToplist',
    }),
    ...mapMutations({
      clearList: 'influencer/clearList',
      clearTopList: 'influencer/clearTopList',
    }),

    async loadInfluencers() {
      this.loading = true

      if ((this.searching && this.showClear) || this.showAllResults) {
        this.clearTopList()
        await this.searchInfluencer(this.params)

        if (this.has_more) {
          this.clearList()
          this.params.perpage = this.total
          await this.searchInfluencer(this.params)
        }
      } else {
        !this.keyword && this.category.id
          ? await this.getToplist(this.category.id)
          : await this.getToplist()
        this.clearList()
      }

      this.loading = false
    },

    async clearInfluencers() {
      await this.clearList()
    },

    clearKeyword() {
      this.keyword = ''
      this.searching = false
      this.searchFollowing()
    },

    searchFollowing: _.debounce(function () {
      this.page = 1
      this.showClear = this.keyword !== ''

      this.clearInfluencers()
      this.clearTopList()
      this.loadInfluencers()
    }, 500),

    async follow(influencer) {
      influencer.is_following = true

      await this.$api.put(`influencer/${influencer.influencer_uid}/follow`)
    },

    async unFollow(influencer) {
      if (influencer.user) {
        this.unfollow.user = influencer.user
        this.unfollow.key = influencer.userKey
        this.unfollow.top = influencer.topKey
      } else {
        this.unfollow.user = influencer
        this.unfollow.key = ''
        this.unfollow.top = ''
      }
      this.unfollow.modalId =
        this.unfollow.user.influencer_uid +
        this.unfollow.key +
        this.unfollow.top

      this.$bvModal.show(this.unfollow.modalId)
    },

    async confirmUnfollow(influencer) {
      await this.$api.delete(
        `influencer/${this.unfollow.user.influencer_uid}/follow`
      )
      influencer.user
        ? (influencer.user.is_following = false)
        : (influencer.is_following = false)

      this.$bvModal.hide(this.unfollow.modalId)
    },

    async selectCategory(cat) {
      this.loading = true
      this.category.id = cat.id
      this.category.name = cat.label

      !this.keyword && this.category.id
        ? await this.getToplist(cat.id)
        : this.searchFollowing()

      this.loading = false
    },

    async clearCategory() {
      this.loading = true
      this.category.id = ''

      this.keyword && !this.category.id
        ? await this.searchFollowing()
        : this.getToplist()

      this.loading = false
    },

    async selectSorting(type) {
      this.sortBy.value = type.value
      this.sortBy.descr = type.description
      await this.loadInfluencers()
    },

    async showAll(toplist) {
      this.sortBy.value = toplist.list_type.value
      this.sortBy.descr = toplist.list_type.description
      this.showAllResults = true
      await this.searchFollowing()
    },

    async backToplist() {
      this.loading = true
      this.showAllResults = false
      this.clearKeyword()
      await this.clearList()
      await this.getToplist()
      this.loading = false
    },

    isDisabled(option) {
      return !!(
        option.id === this.category.id || option.value === this.sortBy.value
      )
    },
  },

  async created() {
    this.clearInfluencers()
  },

  async destroyed() {
    await this.clearList()
  },
}
</script>

<style lang="scss">
.custom-overlay-ii {
  width: 100%;
  position: absolute;
  min-height: 180px;
}
</style>
